export default "__VITE_ASSET__DMvh9SBq__"